import request from "helpers/api_helper";
import { toast } from "react-toastify";

export const getProducts = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `products${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch products");
    return error;
  }
};

export const createProduct = async (data: any, selectedImage? : any) => {
  let formData = new FormData();
  formData.append('data', JSON.stringify(data));
  if (selectedImage) {
    formData.append('featured_image', selectedImage);
  }
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "products",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData, 
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Product created successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to create product");
    return error;
  }
};

export const updateProduct = async (id: number, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `products/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Product updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update product");
    return error;
  }
};

export const deleteProduct = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `products/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Product deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete product");
    return error;
  }
};

export const getProductById = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `products/${id}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch product");
    return error;
  }
};

export const getProductDimensions = async () => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "product_dimension_types",
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch product dimensions");
    return error;
  }
}

export const getProductTypes = async () => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "product_types",
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch product dimensions");
    return error;
  }
}

export const getSurfaceTypes = async () => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "surface_types",
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch product dimensions");
    return error;
  }
}

export const addProductMedia = async (data: any, productId : number) => {
  try {
    const token = localStorage.getItem("token");
    let formData = new FormData();
    formData.append('image', data.image);
    formData.append('is_featured', data.is_featured ? '1' : '0');
    formData.append('type', data.type || 'product');
    
    const args = {
      url: "product_files/" + productId,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData,
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Product media added successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to add product media");
    return error;
  }
}

export const deleteProductMedia = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `product_files/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Product media deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete product media");
    return error;
  }
}

export const updateFeaturedImage = async (id: number, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `set_product_image/${id}`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Product featured image updated successfully");
    }
    return response;
  }
  catch (error: any) {
    toast.error(error.message || "Failed to update product tag.");
    return error;
  }
}

export const updateRelatedProducts = async (id: number, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `related_products/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Product related products updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update product tag.");
    return error;
  }
}


export const restoreProduct = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `products/${id}/restore`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Product restored successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to restore product");
    return error;
  }
};

export const deleteProductPermanently = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `products/${id}/permanent_delete`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Product deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete product");
    return error;
  }
};

export const createProductCSV = async (csv: any) => {
  let formData = new FormData();
  formData.append('csv', csv);
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "products/csv_upload",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData, 
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Product created successfully");
    }
    return response;
  } catch (error: any) {
    return error;
  }
};